import { MinimalConversation } from "@redotech/redo-model/conversation";
import { ConversationFiltersV3 } from "@redotech/redo-model/conversation-filters/conversation-filters";
import { SortableConversationTableColumn } from "@redotech/redo-model/tables/conversations-table-sort";
import { TableSort } from "@redotech/redo-model/tables/table";
import { retry } from "@redotech/util/retry";
import { getMinimalConversations } from "./client/conversations";
import {
  GenericCachedConversationFetcher,
  GenericConversationFetcherResult,
} from "./generic-cached-conversation-fetcher";

export class CachedMinimalConversationFetcher extends GenericCachedConversationFetcher<MinimalConversation> {
  protected async getConversationsWithRetry(params: {
    pageContinue: string | undefined;
    pageStop?: string;
    pageSize: number;
    filters: ConversationFiltersV3 | undefined;
    sort: TableSort<SortableConversationTableColumn> | undefined;
    signal?: AbortSignal;
  }): Promise<GenericConversationFetcherResult<MinimalConversation>> {
    return retry(
      () =>
        getMinimalConversations(this.client, {
          ...params,
          pageContinue: params.pageContinue,
        }),
      4,
      (count) =>
        Temporal.Duration.from({ milliseconds: [500, 1000, 3000][count - 1] }),
    );
  }

  protected async fetchConversations(params: {
    pageContinue?: string;
    pageStop?: string;
    pageSize: number;
    filters?: ConversationFiltersV3;
    sort?: TableSort<SortableConversationTableColumn>;
    signal?: AbortSignal;
  }): Promise<{ data: MinimalConversation[]; pageNext: string | undefined }> {
    return await getMinimalConversations(this.client, {
      ...params,
      pageContinue: params.pageContinue,
    });
  }
}
